import type { Match } from "navigo";
import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import { prices } from "../billing/prices";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import { type Currency, t } from "../locale";
import type { Route, RouteContext } from "../router";
import { state } from "../state";
import { userPlaceholder } from "../user/user";
import { centeredBox } from "../van/centered-box";
import { button, div, h1, p } from "../van/van-tags";

export class PurchaseSmsPage implements Route {
	async #confirmPurchase(): Promise<void> {
		const req = this.#ctx.api.post(`/users/${this.#reactive.user.Id}/sms`);
		req.setSignedInUserAuth();

		errorSection.clear();
		const res = await loadingScreen.waitFor(req.do());
		if (res.ok) {
			const user = await res.json();
			state.setUser(user);
			this.#ctx.router.jump("/account");
		} else {
			errorSection.setText(await res.text());
		}
	}

	async refresh(_: Match): Promise<void> {
		this.#reactive.user = await state.getActiveUser();

		const { Sms } = await prices;
		this.#reactive.amount =
			this.#reactive.user.Country === "SE" ? Sms.Sek : Sms.Eur;
		this.#reactive.currency =
			this.#reactive.user.Country === "SE" ? "SEK" : "EUR";
	}

	#ctx: RouteContext;
	#reactive = reactive({
		amount: 0,
		currency: "SEK" as Currency,
		user: userPlaceholder,
	});

	ChildDom: ChildDom;

	constructor(ctx: RouteContext) {
		this.#ctx = ctx;
		this.ChildDom = centeredBox(
			{ size: "narrow" },
			h1({ class: "title" }, () => t.confirmPurchase),
			div(
				{ class: "field" },
				p(() =>
					t.smsPurchaseDisclaimer(
						this.#reactive.amount,
						this.#reactive.currency,
					),
				),
			),
			div(
				{
					class: "field is-grouped is-multiline",
				},
				div(
					{ class: "control" },
					button(
						{
							class: "button is-primary",
							onclick: () => this.#confirmPurchase(),
						},
						t.confirm,
					),
				),
				div(
					{
						class: "control",
						onclick: () => {
							this.#ctx.router.jump("/account");
						},
					},
					button({ class: "button" }, t.back),
				),
			),
		);
	}
}
